import React from 'react';
import { Modal, Form, Input, Select, InputNumber, Checkbox } from 'antd';
import { SUBSCRIBER_TYPES, SUBSCRIBER_TYPE_LABELS } from '../../models/types';

const SubscriberForm = ({ visible, onClose, onSubmit, initialValues }) => {
  const [form] = Form.useForm();

  React.useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    } else {
      form.resetFields();
    }
  }, [initialValues, visible, form]);

  const handleSubmit = async (values) => {
    try {
      await form.validateFields();
      
      // Filtrer les valeurs pour envoyer SEULEMENT les colonnes qui existent dans Supabase
      const filteredValues = {
        id: values.id,
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email || '',
        phone: values.phone,
        address: values.address,
        city: values.city,
        district: values.district || '',
        type: values.type || SUBSCRIBER_TYPES.INDIVIDUAL,
        registrationNumber: values.registrationNumber || '',
        cin: values.cin || '',
        caution: values.caution !== undefined ? values.caution : 0,
        cautionPaid: values.cautionPaid || false,
        status: values.status || 'active',
        notes: values.notes || '',
        registrationDate: values.registrationDate || new Date().toISOString()
      };
      
      onSubmit(filteredValues);
      form.resetFields();
    } catch (error) {
      // Gestion silencieuse de l'erreur
    }
  };

  return (
    <Modal
      title={initialValues ? 'Modifier un abonné' : 'Ajouter un abonné'}
      open={visible}
      onOk={() => handleSubmit(form.getFieldsValue())}
      onCancel={onClose}
      width={600}
      okText="Enregistrer"
      cancelText="Annuler"
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          type: SUBSCRIBER_TYPES.INDIVIDUAL,
          caution: 100,
          status: 'active'
        }}
      >
        <Form.Item
          label="Prénom"
          name="firstName"
          rules={[{ required: true, message: 'Le prénom est obligatoire' }]}
        >
          <Input placeholder="Prénom" />
        </Form.Item>

        <Form.Item
          label="Nom"
          name="lastName"
          rules={[{ required: true, message: 'Le nom est obligatoire' }]}
        >
          <Input placeholder="Nom" />
        </Form.Item>

        <Form.Item
          label="CIN / Pièce d'identité"
          name="cin"
          rules={[{ required: true, message: 'Le CIN est obligatoire' }]}
        >
          <Input placeholder="CIN/Numéro d'identité" />
        </Form.Item>

        <Form.Item
          label="Téléphone"
          name="phone"
          rules={[{ required: true, message: 'Le téléphone est obligatoire' }]}
        >
          <Input placeholder="Téléphone" />
        </Form.Item>

        <Form.Item
          label="Adresse"
          name="address"
        >
          <Input.TextArea rows={2} placeholder="Adresse complète" />
        </Form.Item>

        <Form.Item
          label="Ville"
          name="city"
          rules={[{ required: true, message: 'La ville est obligatoire' }]}
        >
          <Input placeholder="Ville" />
        </Form.Item>

        <Form.Item
          label="Type d'abonné"
          name="type"
          rules={[{ required: true, message: 'Le type est obligatoire' }]}
        >
          <Select
            placeholder="Sélectionner le type"
            options={Object.entries(SUBSCRIBER_TYPES).map(([key, value]) => ({
              label: SUBSCRIBER_TYPE_LABELS[value],
              value: value
            }))}
          />
        </Form.Item>

        <Form.Item
          label="Montant de la caution (FCFA)"
          name="caution"
          rules={[{ required: true, message: 'La caution est obligatoire' }]}
        >
          <InputNumber min={0} step={10} style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          label="Caution payée"
          name="cautionPaid"
          valuePropName="checked"
        >
          <Checkbox>La caution a été payée</Checkbox>
        </Form.Item>

        <Form.Item
          label="Notes"
          name="notes"
        >
          <Input.TextArea rows={2} placeholder="Notes additionnelles" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SubscriberForm;
